import React from "react";
import ContactForm from "../components/contact-form";
import Footer from "../components/footer";

export default function Contact() {
  return (
    <>
      <ContactForm />
      <Footer />
    </>
  );
}
